import { get } from 'lodash'
import moment from 'moment'

export default {
  day () {
    console.log(this.schedule.weekday)
    return moment(this.schedule.weekday).format('dddd')
  },
  time () {
    return moment(this.schedule.time).format('HH:mm')
  },
  date () {
    return moment(this.schedule.date).format('DD/MM/YYYY')
  },
  degree () {
    return get(this.schedule, 'patient.degree.name', null)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/cancel/resources/computed.js